<template>
  <BaseTableView :head="tableHead">
    <template v-slot:header>
      <tr>
        <th rowspan="2" class="text-left">{{ t['logotip'] }}</th>
        <th
          rowspan="2"
          class="text-left"
          @click="
            click(
              'name',
              $route.query.sort_param && $route.query.sort_param === 'name'
                ? $route.query.sort_value && $route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
            )
          "
        >
          <div class="sorted">
            {{ t['nazvanie-kompanii'] }}
            <IconSort param="name"/>
          </div>
        </th>
        <th rowspan="2" class="max-width-200 text-center">{{ t['y-tunnus'] }}</th>
        <th rowspan="2" class="text-center">{{ t['vat'] }}</th>
        <th colspan="3" class="text-center">{{ t['elektronnyy-schet-faktura'] }}</th>
        <th
          v-if="userType === 'superadmin' ||(userRoleAbilities && userRoleAbilities.includes('view_clients'))"
          rowspan="2"
        />
      </tr>
      <tr class="inner">
        <th class="max-width-250 text-center">{{ t['adres-elektronnoy-nakladnoy-ovt'] }}</th>
        <th class="text-center">{{ t['id-operatora'] }}</th>
        <th class="text-center">{{ t['operator'] }}</th>
      </tr>
    </template>
    <slot />
  </BaseTableView>
</template>

<script>
import IconSort from 'components/icons/IconSort'

export default {
  name: 'WorkClientTable',
  components: {IconSort},
  computed: {
    t() {
      return this.localStorage.translations.pages['setting-client']['tables']
    },
    userRoleAbilities() {
      return this.$store.getters['user/userRoleAbilities']
    },
    userType() {
      return this.$store.getters['user/userType']
    },
    tableHead() {
      return [
        {
          text: this.t['nazvanie-kompanii'],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        { text: this.t['y-tunnus'] },
        { text: this.t['vat'] },
        { text: this.t['adres-elektronnoy-nakladnoy-ovt'] },
        { text: this.t['id-operatora'] },
        { text: this.t['operator'] },
        {active: true},
        {active: true},
      ]
    },
  },
  methods: {
    click(paramName, value) {
      if (paramName && value) {
        this.$routerPushQuerySort(paramName, value)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
tr {
  th {
    font-weight: 500;
    color: #2c2c2c !important;
    border: 1px solid rgba(0, 0, 0, 0.12);
    word-break: break-word;
  }
}

.inner {
  th {
    border-top: none;
    
    &:first-child {
      border-left: none;
    }
  }
}

.max {
  &-width {
    &-200 {
      max-width: 200px;
    }
    
    &-250 {
      max-width: 250px;
    }
  }
}
</style>
